const floatOnScroll = {
    scrollPrev: 0,
    $headerBlock: $('.js--floating'),
    $headerPlace: $('.js--place_for_floating'),
    setContainersForFloat($headerBlock = undefined, $headerPlace = undefined) {
        if ($headerBlock) {
            this.$headerBlock = $headerBlock;
        }
        if ($headerPlace) {
            this.$headerPlace = $headerPlace;
        }
        if (this.$headerPlace.length === 0) {
            this.$headerPlace = this.$headerBlock.parent();
        }
    },
    initFloat() {
        this.calcFloating();
        $(document).scroll(() => {
            this.calcFloating();
        });
    },
    calcFloating() {
        const { $headerBlock, $headerPlace } = this;
        const pointPrepareFloating = $headerPlace.offset().top + $headerBlock.outerHeight();
        const pointFade = pointPrepareFloating + $headerBlock.outerHeight();
        const scrolled = $(window).scrollTop();
        switch (true) {
            case (scrolled >= pointPrepareFloating && scrolled < pointFade):
                $headerBlock.addClass('out');
                break;
            case (scrolled >= pointFade):
                $headerBlock.removeClass('out');
                $headerBlock.addClass('show');
                $headerBlock.addClass('container');
                break;
            default:
                $headerBlock.removeClass('out');
                $headerBlock.removeClass('show');
                $headerBlock.removeClass('container');
        }
    },
};
function FloatOnScroll($headerBlock , $headerPlace) { // Конструктор
    const objFloat = Object.create(floatOnScroll);
    objFloat.setContainersForFloat($headerBlock , $headerPlace);
    return objFloat;
}

export default FloatOnScroll;



// WEBPACK FOOTER //
// ./private/blocks/float_on_scroll/float_on_scroll.js